import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../api';
import { useAuth } from './AuthContext';

const WishlistContext = createContext();

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  useEffect(() => {
    if (user) {
      api.get('/wishlist/ids').then(r => setIds(r.data)).catch(() => {});
    } else {
      setIds([]);
    }
  }, [user]);

  const toggle = useCallback(async (productId) => {
    if (!user) return false; // not logged in
    const isSaved = ids.includes(productId);
    try {
      if (isSaved) {
        await api.delete(`/wishlist/${productId}`);
        setIds(prev => prev.filter(id => id !== productId));
      } else {
        await api.post(`/wishlist/${productId}`);
        setIds(prev => [...prev, productId]);
      }
      return !isSaved;
    } catch { return isSaved; }
  }, [user, ids]);

  const isSaved = useCallback((productId) => ids.includes(productId), [ids]);

  return (
    <WishlistContext.Provider value={{ ids, toggle, isSaved }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
